var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("div", { staticClass: "pdp-gallery" }, [
        _c(
          "div",
          { staticClass: "pdp-gallery__main" },
          [
            _c(
              "swiper",
              {
                ref: "mainSwiper",
                staticClass: "pdp-gallery__main-swiper",
                attrs: { options: _vm.mainSwiperOptions },
                on: {
                  "slide-change": function($event) {
                    return _vm.updateActiveThumb()
                  }
                }
              },
              _vm._l(_vm.productImages, function(image, index) {
                return _c(
                  "swiper-slide",
                  {
                    key: index,
                    staticClass: "pdp-gallery__main-slide",
                    attrs: {
                      "data-slide-index": index,
                      "data-is-variant-image": _vm.isVariantImage(image),
                      "data-color-variant-name": _vm.getVariantName(image)
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "pdp-gallery__main-image",
                      attrs: {
                        src: image.sizes.lg,
                        alt: image.alt,
                        title: image.alt
                      }
                    })
                  ]
                )
              }),
              1
            ),
            _vm.$mq !== "mobile"
              ? _c("div", { staticClass: "pdp-gallery__navigation" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pdp-gallery__navigation-arrow pdp-gallery__navigation-arrow--next"
                    },
                    [
                      _c("icon", {
                        attrs: { name: "chevron-left", size: "18px" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pdp-gallery__navigation-arrow pdp-gallery__navigation-arrow--prev"
                    },
                    [
                      _c("icon", {
                        attrs: { name: "chevron-right", size: "18px" }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm.productImages.length > 1
          ? _c(
              "div",
              { staticClass: "pdp-gallery__thumbnail" },
              [
                _c(
                  "swiper",
                  {
                    ref: "thumbSwiper",
                    staticClass: "pdp-gallery__thumbnail-swiper",
                    attrs: { options: _vm.thumbsSwiperOptions }
                  },
                  _vm._l(_vm.productImages, function(image, index) {
                    return _c(
                      "swiper-slide",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSelectedVariantImage(
                              index,
                              _vm.isVariantImage(image)
                            ),
                            expression:
                              "showSelectedVariantImage(index, isVariantImage(image))"
                          }
                        ],
                        key: index,
                        staticClass: "pdp-gallery__thumbnail-slide",
                        attrs: { "data-slide-index": index }
                      },
                      [
                        _c("img", {
                          staticClass: "pdp-gallery__thumbnail-image",
                          attrs: { src: image.sizes.xs, alt: image.alt },
                          on: {
                            click: function($event) {
                              return _vm.slideToIndex(index, $event)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }